import groq from "groq";

export const footerPartnersQuery = groq`
  *[_type == "partner" && footerLogo != empty] {
    "logo": footerLogo.asset->url,
    "name": title
  }
`;
